import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Journey() {
  const stops = ['Orígenes', 'Ciudades', 'Astronomía', 'Religión', 'Misterios', 'Legado'];
  return <section className="px-5 py-24 md:py-32" data-id="element-139">
      <div className="mx-auto max-w-7xl" data-id="element-140">
        <div className="mb-14 text-center" data-id="element-141">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-142">
            Recorrido de lectura
          </p>
          <h2 className="mt-3 text-4xl font-semibold text-stone-light md:text-6xl" data-id="element-143">
            Un viaje documental
          </h2>
        </div>
        <motion.ol initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center justify-between gap-4 rounded-xl border border-dark-border bg-dark-card p-7 md:flex-row md:gap-2" data-id="element-144">
          {stops.map((stop, index) => <Fragment key={stop} data-id="element-145">
              <li className="flex flex-col items-center gap-3 text-center" data-id="element-146">
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/50 text-sm font-bold text-gold-light" data-id="element-147">
                  {index + 1}
                </span>
                <span className="text-sm font-medium text-stone-light" data-id="element-148">
                  {stop}
                </span>
              </li>
              {index < stops.length - 1 && <ArrowRightIcon className="h-4 w-4 rotate-90 text-gold md:rotate-0" data-id="element-149" />}
            </Fragment>)}
        </motion.ol>
      </div>
    </section>;
}